import { render } from "./adduser.vue?vue&type=template&id=19bcc954"
import script from "./adduser.vue?vue&type=script&lang=js"
export * from "./adduser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__